import { Injectable } from '@angular/core';
import {BehaviorSubject, from, Observable, of} from 'rxjs';
import {Amplify, Auth} from 'aws-amplify';

import { environment } from '../environments/environment';
import {catchError, tap} from 'rxjs/operators';

export interface IUser {
  email: string;
  password: string;
  showPassword: boolean;
  code: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class CognitoService {
  private authenticationSubject: BehaviorSubject<any>;

  Tokentest: string = '';

  constructor() {
    Amplify.configure({
      Auth: environment.cognito,
    });

    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }

  public signUp(user: IUser): Observable<any> {
    return from(Auth.signUp({
      username: user.email,
      password: user.password,
    }));
  }
  public signUp0(user: IUser): Promise<any> {
    return Auth.signUp({
      username: user.email,
      password: user.password,
    });
  }

  resend(username: string) : Observable<any> {
    return from(Auth.resendSignUp(username));
  }

  public confirmSignUp0(user: IUser): Promise<any> {
    return Auth.confirmSignUp(user.email, user.code);
  }

  public confirmSignUp(user: IUser): Observable<any> {
    return from(Auth.confirmSignUp(user.email, user.code));
  }

  public signIn0(user: IUser): Observable<any> {
    return from(Auth.signIn(user.email, user.password).then((retUser) => {
      this.authenticationSubject.next(true);
      let Token = retUser.getSignInUserSession().getAccessToken().getJwtToken();
      this.Tokentest = Token;
    }));
  }

  public signIn(user: IUser): Observable<any> {
    return from(Auth.signIn(user.email, user.password)).pipe(
      tap((retUser) => {
        this.authenticationSubject.next(true);
        let Token = retUser.getSignInUserSession().getAccessToken().getJwtToken();
        this.Tokentest = Token;
      }),
      catchError((error) => {
        console.error('Login failed:', error);
        this.authenticationSubject.next(false);
        return of({error: error.message});
      }),
    );
  }

  public signOut(): Promise<any> {
    return Auth.signOut().then(() => {
      this.authenticationSubject.next(false);
    });
  }

  public isAuthenticated(): Promise<boolean> {
    if (this.authenticationSubject.value) {
      return Promise.resolve(true);
    } else {
      return this.getUser()
        .then((user: any) => {
          if (user) {
            return true;
          } else {
            return false;
          }
        })
        .catch(() => {
          return false;
        });
    }
  }

  public async getUser(): Promise<any> {
    try {
      const userInfo = await Auth.currentUserInfo();
      return userInfo;
    } catch (error) {
      console.error('Error retrieving user information:', error);
      throw error;
    }
    // return Auth.currentUserInfo();
  }

  public getSession(): Promise<any> {
    return Auth.currentSession();
  }

  public updateUser(user: IUser): Promise<any> {
    const userNew = {...user, first_name: 'shaker'};
    return Auth.currentUserPoolUser().then((cognitoUser: any) => {
      return Auth.updateUserAttributes(cognitoUser, userNew);
    });
  }
}
